export const ActionType = {
    readNfc: 'readNfc',
    writeNfc: 'writeNfc',
    captureImage: 'captureImage'
};
